import { render, staticRenderFns } from "./ScrapbookList.vue?vue&type=template&id=707b9b79&"
import script from "./ScrapbookList.vue?vue&type=script&lang=js&"
export * from "./ScrapbookList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports